import type { IconProps } from '../types/IconProps.ts';
export const Mail: IconProps = {
    name: 'Mail',
    children: [
        `<path d="M2 18V6c0-1.1.9-2 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2" />`,
        `<path d="m2 8 9.1 4.55a2 2 0 0 0 1.8 0L22 8" />`,
    ]
};